export default __webpack_public_path__ + "static/logo_citius_tagline_horizontal-ddd91cbf1c63ce21592d391bee4ddf57.svg";